let fallbackCounter = 0;

const randomHex = (byteLength = 16) => {
  if (typeof crypto === "undefined" || typeof crypto.getRandomValues !== "function") {
    return null;
  }
  try {
    const bytes = new Uint8Array(byteLength);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  } catch (error) {
    return null;
  }
};

const fallbackSuffix = () => {
  const counter = (fallbackCounter++).toString(36);
  const stamp = Date.now().toString(36);
  return `${stamp}-${counter}`;
};

export const createRandomId = (prefix) => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    const uuid = crypto.randomUUID();
    return prefix ? `${prefix}-${uuid}` : uuid;
  }

  const hex = randomHex(8);
  const suffix = hex ?? fallbackSuffix();
  return prefix ? `${prefix}-${suffix}` : suffix;
};
